module.exports = __webpack_public_path__ + "static/media/piirla-success-story-banner.ddb15024.webp";